export default __webpack_public_path__ + "media/img/no-avatar-e162209d0cee22b57388bec5dce35ade.svg";